export default [
    {
        name: 'keyboardModel',
        type: 'gltfModel',
        path: 'models/keyboard.glb'
    },
]
